import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-phone-datable',
  templateUrl: './phone-datable.component.html',
  styleUrl: './phone-datable.component.scss'
})
export class PhoneDatableComponent {
  @Input() data: any = undefined;
  @Input() column: any = undefined;
}
